module.exports = __webpack_public_path__ + "22d49512a0dfe1ba18fe47c65748aa2f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/bookshelves/bookshelf-skate.png
// module id = 967
// module chunks = 0